import { css } from 'linaria';

export const fencesOtherTypesSectionTitle = css`
  && {
    margin-bottom: 24px;
  }
`;

export const fencesOtherTypesSwiper = css`
  && {
    @media (--from-desktop) {
      padding: 16px;
      margin: -16px;
    }

    @media (--to-desktop) {
      padding-top: 16px;
      padding-bottom: 16px;
      margin-top: -16px;
      margin-bottom: -16px;
    }
  }
`;

export const fencesOtherTypesSlide = css`
  && {
    width: 377px;
    height: unset;
    margin-right: 24px;

    @media (--only-desktop) {
      width: 297px;
    }

    @media (--to-desktop) {
      width: 210px;
      margin-right: 16px;
    }

    @media (--only-mobile) {
      width: 204px;
    }
  }
`;

export const fencesOtherTypesLink = css`
  && {
    height: 100%;

    &:hover {
      box-shadow: var(--box-shadow-m);

      & button {
        background-color: var(--control-hover-minor);
      }
    }
  }
`;

export const fencesOtherTypesImage = css`
  display: block;
  width: 100%;
  height: 262px;

  @media (--only-desktop) {
    height: 200px;
  }

  @media (--to-desktop) {
    height: 156px;
  }
`;

export const fencesOtherTypesItemContent = css`
  && {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    padding: 24px;

    @media (--to-desktop) {
      padding: 24px 16px;
    }
  }
`;

export const fencesOtherTypesItemName = css`
  margin-bottom: 24px;
`;

export const fencesOtherTypesItemBtn = css`
  && {
    width: max-content;

    @media (--only-mobile) {
      width: 100%;
    }
  }
`;
